import { QuizFormFields } from '@/components/question/forms/quiz/QuizForm';
import { useObjectUrls } from '@/data/hook/shared/useObjectUrls';
import { QuizQuestion } from '@/models/Question';
import adapterQuizForm from '@/utils/questions/adapterQuizForm';

export function useQuizPreviewQuestion(fields: QuizFormFields): QuizQuestion {
  const files = (fields.quizAnswers ?? [])
    .map(answer => answer.mediaFile)
    .filter((mediaFile): mediaFile is File => mediaFile instanceof File);

  const urlByFile = useObjectUrls(files);

  return adapterQuizForm(fields, mediaFile => {
    if (mediaFile instanceof File) {
      return urlByFile.get(mediaFile) ?? null;
    }
    return typeof mediaFile === 'string' ? mediaFile : null;
  });
}
